package org.dronda.lib.validation

import com.github.michaelbull.result.Result
import com.github.michaelbull.result.mapError


abstract class ValidationError

data class NamedValidationError(val name: String, val error: ValidationError) : ValidationError()

fun <T> validate(
    name: String,
    result: Result<T, ValidationError>
): Result<T, ValidationError> =
    result.mapError { error -> NamedValidationError(name, error) }
